<div
  class="standard-dropdown"
  [class.standard-dropdown--open]="isDropdownOpen"
  [class.standard-dropdown--has-value]="
    currentOption.value !== defaultOption?.value
  "
>
  <button
    class="standard-dropdown__button"
    cdkOverlayOrigin
    #trigger="cdkOverlayOrigin"
    (click)="toggleDropdown()"
  >
    <span class="standard-dropdown__button-text">
      {{ this.currentOption.text | i18n }}
    </span>
    <i
      class="standard-dropdown__button-arrow material-icon material-icon--outlined"
    >
      arrow_drop_down
    </i>
  </button>

  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="trigger"
    [cdkConnectedOverlayOpen]="isDropdownOpen"
    [cdkConnectedOverlayLockPosition]="true"
    [cdkConnectedOverlayPositions]="overlayPositions"
    [cdkConnectedOverlayFlexibleDimensions]="true"
    [cdkConnectedOverlayGrowAfterOpen]="true"
    [cdkConnectedOverlayViewportMargin]="16"
    (overlayOutsideClick)="close()"
    [cdkConnectedOverlayWidth]="
      trigger.elementRef.nativeElement.clientWidth + 2
    "
    (detach)="close()"
  >
    <lib-dropdown-menu
      [options]="options"
      [currentOption]="currentOption"
      [highlightSelected]="true"
      (update)="select($event)"
      (tabOut)="close()"
      class="large-buttons"
    ></lib-dropdown-menu>
  </ng-template>
</div>
